import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, watch, nextTick } from 'vue'  
    import store from '@/store'  
    import { buildCoverageStateId } from '@/models/ui/CoverageUiState'
    import {buildCoverageIterationUiStateId} from '@/models/ui/CoverageIterationUiState'
    import { getCoverageState, getCoverageStateTradKey } from '@/enum/CoverageState'
    import { getCoverageStep, getCoverageStepTradKey } from '@/enum/CoverageStep'   
    import MissionEndSimulationSinglePlotsListGen from '@/components/mission/MissionEndSimulationSinglePlotsListGen.vue'
    import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
    import { isAloDbMissionGlobalCoverage } from '@/models/alodb/AloDbMissionGlobal'

    
export default /*#__PURE__*/_defineComponent({
  __name: 'CoverageDetailSinglePlotsList',
  props: {
    isleft: { type: Boolean },
    uiid: null
  },
  setup(__props: any) {

const props = __props as {
      isleft:boolean,
      uiid:string
    };

    
    

    
     
    const missionGlobal = computed(()=> store.myGetters.modifiedAdmMissionGlobal)    
    
    const simulation_uiid = computed(()=> buildSimulationUIStateId(missionGlobal.value.MIG_ID!,"detail")) 
    const coverage_uiid = computed(()=> buildCoverageStateId(missionGlobal.value.MIG_ID!,"detail")) 
    const coverageiteration_uiid = computed(()=> coverageState.value.selectedCoverageId?buildCoverageIterationUiStateId(coverageState.value.selectedCoverageId!,"detail"):null)     
    // const coverageIterationState = computed(()=> coverageiteration_uiid.value?store.myGetters.coverageIterationStateByUiid(coverageiteration_uiid.value):null)

    const allGraphUiState = computed(()=> store.myGetters.allGraphUiStateByUiid(props.uiid))
    const simulationUiState = computed(()=> store.myGetters.simulationUiStateByUiid(simulation_uiid.value))       
    const coverageState = computed(()=> store.myGetters.coverageStateByUiid(coverage_uiid.value))       
    const coverageIteration = computed(()=> coverageState.value.selectedCoverageId?store.myGetters.coverageIterationsById[coverageState.value.selectedCoverageId]:null)   
    const gliderKeys = computed(()=>Object.keys(coverageIteration.value?.resultMipJson || {}).filter(n => n.startsWith('GLIDER')))

    
    const selectedGliderIdx = computed({
      get() {
        return allGraphUiState.value?.gliderIdx ?? -1
      },
      set(value:number) {
        allGraphUiState.value!.gliderIdx = value
      }
    })

    const stateTradKey = computed(()=> getCoverageStateTradKey(getCoverageState(coverageIteration.value?.COV_PROCESSING_STATE))) 
    const stepTradKey = computed(()=> getCoverageStepTradKey(getCoverageStep(coverageIteration.value?.COV_PROCESSING_STEP)))

    async function selectGraph(graph:any){      
      await store.myActions.UI_NAVTO_DETAIL({cmp:'CoverageDetailSinglePlots',uiid:simulation_uiid.value,isleft:!props.isleft,'label':graph.name})             
      //on attend que le composant soit créé
      nextTick(()=> {
        const tabsMission = !props.isleft? simulationUiState.value.tabsleft: simulationUiState.value.tabsright
        store.myActions.UI_SET_GRA_CONFIG({config:graph,uiid:tabsMission.selected})
      })
  }

  
return { __sfc: true,props, missionGlobal, simulation_uiid, coverage_uiid, coverageiteration_uiid, allGraphUiState, simulationUiState, coverageState, coverageIteration, gliderKeys, selectedGliderIdx, stateTradKey, stepTradKey, selectGraph, MissionEndSimulationSinglePlotsListGen, isAloDbMissionGlobalCoverage }
}

})